import { TypeDefinition } from "../generic";

export class MemberStatuses {
    public static Active: TypeDefinition = { id: 1, name: "Active" };
    public static Inactive: TypeDefinition = { id: 2, name: "Inactive" };
    public static Deceasesd: TypeDefinition = { id: 3, name: "Deceasesd" };
    public static Cancelled: TypeDefinition = { id: 4, name: "Cancelled" };
    public static PendingApplicant: TypeDefinition = { id: 5, name: "PendingApplicant" };
    public static Dropped: TypeDefinition = { id: 6, name: "Dropped" };
    public static Duplicate: TypeDefinition = { id: 7, name: "Duplicate" };

    public static Values: TypeDefinition[] = [
        MemberStatuses.Inactive,
        MemberStatuses.Active,
        MemberStatuses.Deceasesd,
        MemberStatuses.Cancelled,
        MemberStatuses.PendingApplicant,
        MemberStatuses.Dropped,
        MemberStatuses.Duplicate,
    ];

    public static isActive = (statusId: number) => {
        return statusId === MemberStatuses.Active.id;
    }

    public static isActiveOrApplicant = (statusId: number) => {
        return statusId === MemberStatuses.Active.id
            || statusId === MemberStatuses.PendingApplicant.id;
    }
}



// WEBPACK FOOTER //
// ./src/models/member/MemberStatuses.ts